var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScopePolicyWrite = function SvgScopePolicyWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7 14.667H5.867c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.533c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.427-.218.988-.218 2.108-.218h4.266c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 9s2-.953 2-2.383V4.949l-1.458-.522a1.6 1.6 0 0 0-1.084 0L6 4.95v1.668C6 8.047 8 9 8 9M9.117 13.95c.014-.129.021-.193.04-.253a.6.6 0 0 1 .073-.15c.035-.053.08-.099.172-.19l4.1-4.1a.878.878 0 1 1 1.24 1.242l-4.099 4.1a1.3 1.3 0 0 1-.19.171.6.6 0 0 1-.15.072c-.06.02-.124.027-.252.041L9 15z"
  })));
};
export default SvgScopePolicyWrite;